import React from 'react';
import ReactDOM from 'react-dom';

import Header from './components/static-markup/header';
import Dashboard from './components/dashboard';
import Footer from './components/static-markup/footer';
import './index.scss';

ReactDOM.render(
  <React.StrictMode>
    <>
      <Header />
      <Dashboard />
      <Footer />
    </>
  </React.StrictMode>,
  document.getElementById('root'),
);
